import styles from '@/styles/press.module.css';

import { useState } from 'react';
import { IconPlayerPlayFilled } from '@tabler/icons-react';
import Image from 'next/image';

interface FilmFacadeProps {
  videoId: string;
  title: string;
  poster: string;
}

/**
 * A poster with a play button that only loads the (privacy-enhanced) YouTube player when clicked, so
 * the page sets no third-party cookies and stays fast until a visitor chooses to watch.
 */
const FilmFacade = ({ videoId, title, poster }: FilmFacadeProps) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className={styles.film}>
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button type="button" className={styles.filmPoster} onClick={() => setPlaying(true)}>
          <Image src={poster} alt="" fill sizes="(max-width: 760px) 100vw, 720px" />
          <span className={styles.playButton}>
            <IconPlayerPlayFilled size={26} aria-hidden="true" />
          </span>
          <span className="sr-only">Play: {title}</span>
        </button>
      )}
    </div>
  );
};

export default FilmFacade;
